<template>
    <div class="contact-bg w-full h-[1100px] md:h-[808px] flex justify-center items-center" id="contact-scroll">   
        <div class="w-full xl:w-[1107px] h-full md:h-[708px] md:flex justify-center items-center mx-auto py-2 md:py-8 px-2 xl:px-0">
            <div class="w-full md:w-[355px] lg:w-[560px] h-[484px] lg:h-[584px] px-10 z-20 md:-mr-7 bg-bgdarkGray flex justify-center items-center rounded-3xl shadow-contShadow">
                <div class="space-y-4">
                    <label class="text-white text-2xl lg:text-3xl xl:text-4xl font-nunito">
                    <!-- Contact Us -->{{$t('contact-us ')}}
                    </label>
                    <div class="flex gap-6 p-3">
                        <div class="w-[50px] lg:w-[70px] flex justify-center">
                            <svg width="50" height="41" fill="none" viewBox="0 0 50 41">
                              <path fill="#fff" d="M42.1875 0c2.072 0 4.0591.8231 5.5243 2.28823C49.1769 3.75336 50 5.7405 50 7.8125v25c0 2.072-.8231 4.0591-2.2882 5.5243-1.4652 1.4651-3.4523 2.2882-5.5243 2.2882H7.8125c-2.072 0-4.05914-.8231-5.52427-2.2882C.8231 36.8716 0 34.8845 0 32.8125v-25c0-2.072.8231-4.05914 2.28823-5.52427C3.75336.8231 5.7405 0 7.8125 0h34.375Zm4.6875 12.3781L25.7937 24.7844c-.1993.117-.422.1883-.6522.2089-.2302.0205-.4621-.0103-.679-.0902l-.2562-.1187-21.0813-12.4v20.4281c0 1.2432.49386 2.4355 1.37294 3.3146.87907.879 2.07136 1.3729 3.31456 1.3729h34.375c1.2432 0 2.4355-.4939 3.3146-1.3729.879-.8791 1.3729-2.0714 1.3729-3.3146V12.3781ZM42.1875 3.125H7.8125c-1.2432 0-2.43549.49386-3.31456 1.37294C3.61886 5.37701 3.125 6.5693 3.125 7.8125v.94375L25 21.625 46.875 8.75v-.9375c0-1.2432-.4939-2.43549-1.3729-3.31456-.8791-.87908-2.0714-1.37294-3.3146-1.37294Z"/>
                          </svg> 
                        </div>
                        <div class="text-white flex flex-col space-y-1 tracking-wide">
                            <label class="font-semibold text-white font-nunito">
                            <!-- Email -->{{$t('email')}}
                            </label>
                            <label class="font-light">sushant.godghate@sekai-ichi.com</label>
                        </div>
                    </div>

                    <div class="flex gap-6 p-3">
                        <div class="w-[50px] lg:w-[70px] flex justify-center">
                            <svg  width="40" height="50" fill="none" viewBox="0 0 40 50">
                              <path fill="#fff" d="M11.0417.264844 8.80046.940036C6.80482 1.54186 5.02263 2.70124 3.66366 4.28173c-1.35897 1.58049-2.23818 3.5163-2.53413 5.57959C.201143 16.3256 2.27673 23.884 7.28127 32.5521 12.2733 41.1983 17.7686 46.7687 23.8172 49.2068c1.9435.7833 4.071.992 6.1296.6014 2.0586-.3907 3.9617-1.3643 5.4831-2.8051l1.6942-1.6067c1.1002-1.0412 1.7849-2.4464 1.9269-3.9545.142-1.5081-.2684-3.0164-1.1548-4.2447l-4.2387-5.8767c-.5731-.7933-1.38-1.3875-2.3078-1.6992-.9277-.3117-1.9297-.3252-2.8655-.0388l-6.4112 1.96-.1657.0312c-.7065.1032-2.3382-1.4254-4.37-4.9451-2.1256-3.6823-2.5632-5.8361-1.9787-6.3925l3.2603-3.0415c1.1923-1.1113 2.0067-2.5681 2.329-4.1658.3224-1.5977.1365-3.25623-.5316-4.74293L18.547 3.68769c-.6223-1.3837-1.7265-2.4939-3.1068-3.12366-1.3803-.6297588-2.9425-.736095-4.3954-.299186h-.0031ZM15.6993 4.9693l2.0631 4.59818c.4018.89162.5141 1.88672.3212 2.84542-.1928.9587-.6812 1.833-1.3965 2.4998l-3.2697 3.0447c-2.0912 1.9818-1.3973 5.364 1.416 10.2341 2.6445 4.5826 5.0577 6.8457 7.6522 6.4518l.3876-.0812L29.4 32.5709c.312-.0959.6462-.0916.9556.0121.3095.1037.5787.3017.7699.5662l4.2387 5.8766c.4439.6141.6496 1.3685.5788 2.1229-.0707.7544-.413 1.4574-.9632 1.9783l-1.6974 1.6067c-1.0867 1.0285-2.4459 1.7234-3.916 2.0021-1.47.2787-2.9892.1296-4.377-.4298-5.3077-2.1381-10.3248-7.2239-14.99798-15.3168-4.6857-8.1117-6.58312-15.0105-5.76726-20.684.21119-1.47408.83915-2.85713 1.80995-3.98631.97079-1.12918 2.24401-1.95748 3.66973-2.38738l2.24126-.67519c.7266-.21835 1.5079-.16496 2.1981.15022.6901.31518 1.2421.87063 1.553 1.56276h.0031Z"/>
                          </svg>
                        </div>
                        <div class="text-white flex flex-col space-y-1 tracking-wide">
                            <label class="font-semibold text-white font-nunito"><!-- Phone -->{{$t('phone')}}</label>
                            <div class="flex gap-6">
                                <label class="font-light">+91 82-0885-7068</label>
                                <label class="font-light">+81 80-4186-1714</label>
                            </div>
                        </div>
                    </div>

                    <div class="flex gap-6 p-3">
                        <div class="w-[50px] lg:w-[70px] flex justify-center">
                            <svg width="50" height="50" fill="none" viewBox="0 0 50 50">
                              <path fill="#fff" d="M23.5293 47.0574c2.5587 0 5.0292-.4117 7.3351-1.1646-1.1387-1.4808-2.1002-3.0897-2.8647-4.794-1.4587 2.0617-3.0411 3.0175-4.4704 3.0175-1.9323 0-4.1381-1.7352-5.9469-5.6116-.6885-1.5075-1.2378-3.0747-1.6411-4.6822h10.5408c.0353-1.0058.1736-1.9911.403-2.9411H15.3119c-.4087-2.4294-.6114-4.8891-.6059-7.3527 0-2.597.2147-5.0734.6059-7.3527h16.4348c.3529 2.0705.5647 4.3028.6 6.641.8882-.6059 1.8558-1.1029 2.8999-1.4706-.076-1.7319-.2498-3.4581-.5206-5.1704h8.038c.6176 1.6147 1.0382 3.3264 1.2323 5.1057 1.1.3736 2.1205.8882 3.0499 1.5206-.1427-4.6204-1.6433-9.0965-4.3144-12.86925-2.6711-3.77278-6.3944-6.67516-10.705-8.34476C27.7163-.0813127 23.0094-.444167 18.4938.545032 13.9783 1.53423 9.85413 3.83165 6.63634 7.15046 3.41854 10.4693 1.24964 14.6624.40044 19.2064c-.849203 4.5439-.3410876 9.2374 1.46091 13.4943 1.80199 4.2569 4.81802 7.8888 8.67155 10.442 3.8535 2.5533 8.3737 3.9148 12.9964 3.9147Zm0-44.1163c1.9323 0 4.1381 1.73524 5.9469 5.6116.6382 1.37054 1.194 2.947 1.644 4.6822H15.9383c.45-1.7352 1.0059-3.31166 1.647-4.6822 1.8029-3.87636 4.0087-5.6116 5.944-5.6116Zm-8.6115 4.36752c-.8685 1.90233-1.5416 3.88798-2.0088 5.92628H5.69451C8.17749 8.94348 12.1215 5.68851 16.8059 4.06459c-.7088.97056-1.3411 2.07053-1.8881 3.24403ZM12.3296 16.176c-.3806 2.4323-.5694 4.8908-.5647 7.3527 0 2.5588.1971 5.0352.5676 7.3527H4.29455c-.89695-2.3475-1.35552-4.8396-1.3529-7.3527 0-2.5881.4794-5.0704 1.3529-7.3527h8.03795-.0029Zm.5794 17.6465c.5176 2.1853 1.197 4.1823 2.0088 5.9263.547 1.1735 1.1793 2.2735 1.8881 3.2441-4.6844-1.624-8.62841-4.8789-11.11139-9.1704h7.21739-.0029ZM30.2526 4.06459c4.6846 1.62369 8.6287 4.87872 11.1114 9.17031h-7.2174c-.4673-2.0383-1.1403-4.02393-2.0088-5.92628-.5236-1.13951-1.156-2.22587-1.8881-3.24403h.0029ZM49.9991 34.3578c0-5.9792-4.3087-10.8261-10.2909-10.8261-5.9792 0-10.2967 4.8469-10.2967 10.8261 0 4.4822 2.8881 10.3821 9.5761 15.3996.4265.3235 1.0147.3235 1.4412 0 6.6939-5.0175 9.5703-10.9174 9.5703-15.3996Zm-5.8822-.5353c0 1.1701-.4648 2.2922-1.2921 3.1195-.8274.8274-1.9495 1.2922-3.1195 1.2922-1.1701 0-2.2922-.4648-3.1195-1.2922-.8274-.8273-1.2922-1.9494-1.2922-3.1195 0-1.17.4648-2.2921 1.2922-3.1195.8273-.8273 1.9494-1.2921 3.1195-1.2921 1.17 0 2.2921.4648 3.1195 1.2921.8273.8274 1.2921 1.9495 1.2921 3.1195Z"/>
                          </svg>
                        </div>
                        <div class="text-white flex flex-col space-y-1 tracking-wide">
                            <label class="font-semibold text-white font-nunito">
                            <!-- Address -->{{$t('address')}}
                            </label>
                            <label class="font-light uppercase text-sm">
                                JAI-BHIM House, 1-4-34, SAKAECHODORI, 
                                TSURUMI-KU, YOKOHAMA-SHI,
                                KANAGAWA-KEN 230-0038, JAPAN.</label>
                        </div>
                    </div>
                </div>
            </div>
            <div class="w-full md:w-[400px] lg:w-[600px] h-[555px] lg:h-[655px] -mt-8 md:mt-0 z-10 bg-bgContactGray rounded-3xl shadow-contUsShadow flex justify-center">
                <div class="w-[320px] lg:w-[460px] h-[495px]">
                    <label class="text-white text-2xl lg:text-3xl xl:text-4xl font-nunito py-2 flex mt-6">
                    <!-- Or Write Us -->{{$t('or-write-us')}}
                    </label>
                    <div class="space-y-7 pt-5">
                        <div class="flex gap-2 lg:gap-3.5">
                            <div class="w-6/12 relative">
                                <input type="text" name="first-name" 
                                v-model.trim="contact.firstname" 
                                ref="firstName" 
                                @blur="clearValidation('firstname')"
                                :placeholder="$t('first-name')" class="py-1.5 px-2 text-sm lg:text-base text-white w-full rounded bg-transparent ring-1 ring-white focus:outline-none focus:ring-1 focus:ring-blue-600" autocomplete="off">
                                <div v-if="!errors.firstname" class="absolute mt-1 text-xs text-red-400" >
                                <!-- The name field is required. -->{{$t('name-field-required')}}
                                </div>
                            </div>
                            <div class="w-6/12 relative">
                                <input type="text" name="last-name" 
                                v-model.trim="contact.lastname" 
                                ref="lastName" 
                                @blur="clearValidation('lastname')"
                                :placeholder="$t('last-name')" class="py-1.5 px-2 text-sm lg: text-white w-full rounded bg-transparent ring-1 ring-white focus:outline-none focus:ring-1 focus:ring-blue-600" autocomplete="off">
                                <div v-if="!errors.lastname" class="absolute mt-1 text-xs text-red-400" >
                                <!-- The last name field is required. -->{{$t('last-name-field-required')}}
                                </div>
                            </div>
                        </div>

                        <div class="w-full">
                            <input type="text" v-model.trim="contact.email" ref="email" @blur="!errors.isValidEmail ? clearValidation('isValidEmail') : clearValidation('email')" name="email" :placeholder="$t('email')" class="py-1.5 px-2 text-sm lg: text-white w-full rounded bg-transparent ring-1 ring-white focus:outline-none focus:ring-1 focus:ring-blue-600">
                            <div v-if="!errors.email" class="absolute mt-1 text-xs text-red-400" >
                            <!-- The email field is required. -->{{$t('email-field-required')}}
                            </div>
                            <div v-if="!errors.isValidEmail" class="absolute mt-1 text-xs text-red-400" ><!-- Invalid email -->{{$t('invalid-email')}}.</div>
                        </div>
                        <div class="w-full flex gap-2">
                            <select v-model.trim="contact.phoneCode" ref="phoneCode" @change="clearValidation('phoneCode')" class="w-10/12 h-[38px] rounded-l shadow-inputShadow ring-1 ring-gray-300 focus:outline-none focus:ring-1 focus:ring-blue-600 px-2">
                                <option value=""><!-- Country Code -->{{$t('country-code')}}</option>
                                <option v-for="(code, index) in country_code" :key="index" :value="code.phonecode+'#@#'+code.id" >{{ code.name}} (+{{ code.phonecode }})</option>
                            </select>
                            <div v-if="!errors.phoneCode" class="absolute mt-1 text-xs text-red-400" >
                            <!-- The phone code field is required. -->{{$t('phone-code-field-required')}}
                            </div>
                            <input type="text" v-model.trim="contact.contactNumber" ref="contactNumber" @blur="clearValidation('contactNumber')" name="contact-number" :placeholder="$t('contact-number\n')" class="py-1.5 px-2 text-sm lg: text-white w-full rounded bg-transparent ring-1 ring-white focus:outline-none focus:ring-1 focus:ring-blue-600">
                            <div v-if="!errors.contactNumber" class="absolute mt-1 text-xs text-red-400" >
                            <!-- The contact number field is required. -->{{$t('contact-number-field-required')}}
                            </div>
                        </div>
                        <div class="w-full">
                            <input type="text" v-model.trim="contact.company" ref="company" @blur="clearValidation('company')" name="company" :placeholder="$t('company-name ')" class="py-1.5 px-2 text-sm lg: text-white w-full rounded bg-transparent ring-1 ring-white focus:outline-none focus:ring-1 focus:ring-blue-600">
                            <div v-if="!errors.company" class="absolute mt-1 text-xs text-red-400" >
                            <!-- The company field is required. -->{{$t('company-field-required')}}
                            </div>
                        </div>
                        <div class="w-full">
                            <textarea type="text" v-model.trim="contact.message" ref="message" @blur="clearValidation('message')" :placeholder="$t('comment')" rows="4" class="py-1.5 px-2 text-sm lg: text-white w-full rounded bg-transparent ring-1 ring-white focus:outline-none focus:ring-1 focus:ring-blue-600"></textarea>
                            <div v-if="!errors.message" class="absolute mt-1 text-xs text-red-400" >The message field is required.</div>
                        </div>

                        <div>
                            <vue-recaptcha :sitekey="siteKey" @verify="onVerify"
                                @expired="onExpired" @blur="clearValidity('reCaptcha')"></vue-recaptcha>
                            <span v-if="!errors.reCaptcha" class="pt-2 text-xs text-red-400">
                            <!-- Please click on checkbox. -->{{$t('please-click-on-checkbox')}}
                            </span>
                        </div>
       
                        <div class="flex justify-end">
                            <button type="button" :disabled="isSubmit" @click="submitContact()" class="rounded w-40 px-2 py-1 h-11" :class="[isSubmit ? 'font-semibold cursor-not-allowed  bg-gray-200 text-white flex justify-center border border-gray-300 items-center gap-2' : 'text-base font-semibold bg-bgSubmit text-white flex justify-center border border-blue-700 items-center gap-2']">
                                <svg v-if="isSubmit" class="animate-spin h-5 w-5 text-gray-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" ><circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle><path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path></svg>
                                <span v-show="!isSubmit" class="flex items-center gap-2">
                                    <!-- Submit -->{{$t('submit')}}
                                </span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';
     import { VueRecaptcha } from 'vue-recaptcha';

    export default {
        data: function() {
            return {
                isSubmit: false, 
                contact:{
                    firstname: '',
                    lastname: '',
                    phoneCode:'',
                    email:'',
                    contactNumber:'',
                    company:'',
                    message:'',
                    reCaptcha: false,
                },
                errors:{
                   firstname:true,
                   lastname:true,
                   phoneCode:true,
                   email:true,
                   isValidEmail:true,
                   contactNumber:true,
                   company:true,
                   message:true,
                   reCaptcha: true,
                },
                siteKey:process.env.VUE_APP_RECAPTCHA_SITE_KEY,
                country_code:[],
                email_reg: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
                intervalId:''
            }
        }, 
         components: { 
            VueRecaptcha,
        },
        methods: {
            async submitContact(){
                if (this.validateForm()) {
                    try {
                        this.gIndicator('start');
                        const res =  await this.$store.dispatch("contactUs/store",{payload:this.contact});
                        if(res.success){
                            let frmData = {
                                'from_user_id' : 0,
                                'to_user_id' : res.superadmin_id,
                                'message' : this.contact.email+' sent Message Successfully.',
                                'seen' : 0,
                                'link' : 'contact-us/reply/'+res.contact_id,
                                'type' : 'Contact Us',
                                'ProductCode' : process.env.VUE_APP_PRODUCT_CODE_ROLE
                            }
                            this.bellNotification(frmData);
                            setTimeout(() => {
                                this.clearFields();
                                this.gIndicator('stop');
                                this.$toast(this.$t('your-message-sent-successfully'),this.$store.getters["getDkToastSuccess"]);
                                this.isSubmit = false;
                            }, 1000)
                        }
                    } catch (error) {
                        this.gIndicator('stop');
                        console.log("Error in submitContact response", error);
                    }
                }
            },

            validateForm() {
                let isFormValid = true;
                if (!this.contact.firstname && !this.contact.lastname && !this.contact.email && !this.contact.phoneCode && !this.contact.contactNumber && !this.contact.company && !this.contact.message && !this.contact.reCaptcha) {
                    this.$refs.firstName.focus();
                    this.errors.firstname = false;
                    this.errors.lastname = false;
                    this.errors.email = false;
                    this.errors.phoneCode = false;
                    this.errors.contactNumber = false;
                    this.errors.company = false;
                    this.errors.message = false;
                    this.errors.reCaptcha = false;
                    isFormValid = false;
                }else if (!this.contact.firstname) {
                    this.$refs.firstName.focus();
                    this.errors.firstname = false;
                    isFormValid = false;
                } else if (!this.contact.lastname) {
                    this.$refs.lastName.focus();
                    this.errors.lastname = false;
                    isFormValid = false;
                }else if (!this.contact.email) {
                    this.$refs.email.focus();
                    this.errors.email = false;
                    isFormValid = false;
                }else if (this.email && !this.email_reg.test(this.email)) {
                    this.$refs.email.focus();
                    this.errors.isValidEmail = false;
                    isFormValid = false;
                }else if (!this.contact.phoneCode) {
                    this.$refs.phoneCode.focus();
                    this.errors.phoneCode = false;
                    isFormValid = false;
                }else if (!this.contact.contactNumber) {
                    this.$refs.contactNumber.focus();
                    this.errors.contactNumber = false;
                    isFormValid = false;
                }else if (!this.contact.company) {
                    this.$refs.company.focus();
                    this.errors.company = false;
                    isFormValid = false;
                }else if (!this.contact.message) {
                    this.$refs.message.focus();
                    this.errors.message = false;
                    isFormValid = false;
                } else if (!this.contact.reCaptcha) {
                    this.errors.reCaptcha = false;
                    isFormValid = false;
                }
                
                return isFormValid;
            },
            async onVerify(response){
                if(response){
                    let payload = {
                        response : response,
                        type:'seller'
                    }
                   let res = await this.$store.dispatch("contactUs/verifyCaptcha",{payload:payload});
                    if(res.success){
                        this.contact.reCaptcha = true;
                        this.errors.reCaptcha = true;
                    }else{
                        this.contact.reCaptcha = false;
                        this.error.reCaptcha = false;
                        this.$toast(this.$t('invalid-recaptcha'),this.$store.getters["getDkToastError"]);
                    }
                }
            },
            onExpired(response){
                if(response){
                    this.contact.reCaptcha = false;
                    this.errors.reCaptcha = true;
                }
            },
            clearValidation(input){
                this.errors[input] = true;
            },
            async getCountryCode(){
                try {
                    const countries =  await this.$store.dispatch("getCountryCode");
                    this.country_code = countries.data;
                } catch (error) {
                    console.log("Error in getCountryCode response", error);
                }
            },
            async loadFunctions(){
                clearInterval(this.intervalId);
                await this.getCountryCode();
            },
            clearFields(){
                this.contact ={
                    firstname: '',
                    lastname: '',
                    phoneCode:'',
                    email:'',
                    contactNumber:'',
                    company:'',
                    message:'',
                    reCaptcha: false,
                };
                this.errors={
                   firstname:true,
                   lastname:true,
                   phoneCode:true,
                   email:true,
                   isValidEmail:true,
                   contactNumber:true,
                   company:true,
                   message:true,
                   reCaptcha: true,
                };
                grecaptcha.reset();
            }
        },
        mounted() {
            window.scrollTo(0,0);
            this.intervalId = setInterval(() => {
				this.loadFunctions();
			}, 1000);
        }
    };
</script>

<style>
    .contact-bg{
        background: linear-gradient(301.99deg, #022A93 8.07%, #315CCD 49.78%, #D9D9D9 91.51%);
    }
</style>


